module.exports = __webpack_public_path__ + "img/mama-1.c669cca6.png";